/* ==============================================================================
   LG COMPLETA TU COMPRA — botón «Añadir» de cada accesorio (snippets/lg-completa-compra.liquid).
   <lg-cc-form> hereda de <product-form> de Dawn (product-form.js): añade al carrito por AJAX
   y abre el carrito lateral. Tiene su propio nombre para que product-info.js, que busca
   `product-form` dentro de la ficha, siga encontrando siempre el formulario principal.
   ============================================================================== */
(function () {
  function definir() {
    if (customElements.get('lg-cc-form')) return true;
    var Base = customElements.get('product-form');
    if (!Base) return false;
    customElements.define('lg-cc-form', class extends Base {});
    return true;
  }
  if (!definir()) customElements.whenDefined('product-form').then(definir);
})();
